module.exports = __webpack_public_path__ + "img/reach-default.cebe61c0.jpg";